package one.healthium.log_period.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ifaandroid.feature.profile.log_period.generated.resources.Res
import ifaandroid.feature.profile.log_period.generated.resources.ic_calendar
import loco.GENERAL_SAVE
import loco.LOG_PERIOD_MARK_DATES_TITLE
import one.healthium.log_period.ui.utils.LogPeriodEvents
import one.healthium.log_period.ui.utils.PeriodCalendar
import one.healthium.log_period.ui.utils.PeriodCalendarViewModel
import one.healthium.ui.common.event_producer.EventEffect
import one.healthium.ui.compose.components.AppProgressButton
import one.healthium.ui.compose.components.AppSheetTopBar
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black
import one.healthium.ui.compose.theme.white_1
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


interface LogPeriodEvenDelegate {
    fun onCloseClicked()
    fun onPeriodUpdated()
}

@Composable
fun LogPeriodScreen(
    evenDelegate: LogPeriodEvenDelegate,
) {
    val viewModel = koinViewModel<PeriodCalendarViewModel>()
    val state by viewModel.state.collectAsState()
    val scrollState = rememberScrollState()

    EventEffect(viewModel.events) { event ->
        when (event) {
            is LogPeriodEvents.PeriodUpdated -> evenDelegate.onPeriodUpdated()
        }
    }

    Column(
        modifier = Modifier
            .verticalScroll(scrollState)
            .navigationBarsPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppSheetTopBar(
            onCloseClicked = evenDelegate::onCloseClicked,
        )
        Image(
            painter = painterResource(Res.drawable.ic_calendar),
            contentDescription = null,
        )
        Spacer(modifier = Modifier.height(16.dp))
        Text(
            text = stringResource(loco.Res.string.LOG_PERIOD_MARK_DATES_TITLE),
            style = AppTheme.textStyles.poppins30SemiBold,
            color = black
        )
        Spacer(modifier = Modifier.height(36.dp))
        Box(
            modifier = Modifier
                .background(
                    color = white_1,
                    shape = RoundedCornerShape(32.dp)
                )
                .height(404.dp)
                .padding(20.dp),
        ) {
            PeriodCalendar(
                selectedDates = state.periodDays,
                onSelectionChanged = { date ->
                    viewModel.onCalendarClick(date)
                }
            )
        }
        Spacer(modifier = Modifier.height(36.dp))
        AppProgressButton(
            modifier = Modifier.defaultMinSize(minWidth = 176.dp),
            onClick = { viewModel.onPeriodsSaveClicked() },
            text = stringResource(loco.Res.string.GENERAL_SAVE),
        )
        Spacer(Modifier.height(24.dp))

    }
}